export enum TagTypesEnum {
  Auth = 'Auth',

  Account = 'Account',
  Application = 'Application',
  Billing = 'Billing',
  Connection = 'Connection',
  Connector = 'Connector',
  ConnectorFTP = 'ConnectorFTP',
  Consumer = 'Consumer',
  Credential = 'Credential',
  Integration = 'Integration',
  Members = 'Members',
  Payment = 'Payment',
  Plans = 'Plans',
  Subscription = 'Subscription',
  ApplicationRequest = 'ApplicationRequest',
  ConsumerRequest = 'ConsumerRequest',
  ConsumerEvents = 'ConsumerEvents',
  UnifyApi = 'UnifyApi',
  User = 'User',
  UserMeta = 'UserMeta',
  UserProfile = 'UserProfile',
  UserSettings = 'UserSettings',
  Webhook = 'Webhook',
}
